export const renderTwilightShiftAstrolabe = (
    ctx: CanvasRenderingContext2D,
    x: number,
    y: number,
    scale: number,
    rotation: number,
    globalAlpha: number,
    glowIntensity: number,
    time: number
) => {
    ctx.save();
    ctx.translate(x, y);
    ctx.scale(scale, scale);
    ctx.globalAlpha = globalAlpha;

    // --- 1. The Supermassive Core (Black Hole / Star Hybrid) ---
    ctx.save();
    ctx.rotate(time * 0.5);
    // Outer accretion disk glow
    ctx.beginPath();
    ctx.arc(0, 0, 40, 0, Math.PI * 2);
    const coreGlow = ctx.createRadialGradient(0, 0, 10, 0, 0, 40);
    coreGlow.addColorStop(0, '#FFFFFF');
    coreGlow.addColorStop(0.3, '#00FFFF');
    coreGlow.addColorStop(0.6, '#8A2BE2'); // BlueViolet
    coreGlow.addColorStop(1, 'rgba(0, 0, 0, 0)');
    ctx.fillStyle = coreGlow;
    ctx.fill();

    // The event horizon (pure black center)
    ctx.beginPath();
    ctx.arc(0, 0, 15, 0, Math.PI * 2);
    ctx.fillStyle = '#050508';
    ctx.fill();

    // Swirling temporal bands inside the core
    for (let i = 0; i < 3; i++) {
        ctx.save();
        ctx.rotate((time * 0.5 + i * Math.PI * 2) / 3); // Slowed down from time*3
        ctx.beginPath();
        ctx.ellipse(0, 0, 25, 6, rotation * 0.2, 0, Math.PI * 2); // Slowed from rotation*0.5
        ctx.strokeStyle = `rgba(255, 255, 255, ${0.5 + Math.sin(time * 3) * 0.3})`; // Slowed pulse
        ctx.lineWidth = 1.5;
        ctx.stroke();
        ctx.restore();
    }
    ctx.restore();

    // Helper to draw metallic 3D-like rings
    const drawArmillaryRing = (
        radius: number,
        thickness: number,
        tiltAxis: number,
        tiltAngle: number,
        spin: number,
        colorTheme: ('gold' | 'silver' | 'bronze')
    ) => {
        ctx.save();
        ctx.rotate(tiltAxis); // Orient the axis of tilt

        // Calculate the squish factor for 3D tilt
        const squish = Math.cos(tiltAngle);

        // Spin the ring along its own tilted plane
        ctx.rotate(spin);

        ctx.beginPath();
        ctx.ellipse(0, 0, radius, radius * squish, 0, 0, Math.PI * 2);

        let grad;
        if (colorTheme === 'gold') {
            grad = ctx.createLinearGradient(-radius, -radius * squish, radius, radius * squish);
            grad.addColorStop(0, '#FFDF00');
            grad.addColorStop(0.5, '#D4AF37');
            grad.addColorStop(1, '#8B6508');
        } else if (colorTheme === 'silver') {
            grad = ctx.createLinearGradient(-radius, radius * squish, radius, -radius * squish);
            grad.addColorStop(0, '#FFFFFF');
            grad.addColorStop(0.5, '#C0C0C0');
            grad.addColorStop(1, '#696969');
        } else {
            grad = ctx.createLinearGradient(0, -radius * squish, 0, radius * squish);
            grad.addColorStop(0, '#FF7F50');
            grad.addColorStop(0.5, '#CD7F32'); // Bronze
            grad.addColorStop(1, '#8B4513');
        }

        ctx.strokeStyle = grad;
        ctx.lineWidth = thickness;
        ctx.stroke();

        // Inner glowing track line
        ctx.beginPath();
        ctx.ellipse(0, 0, radius, radius * squish, 0, 0, Math.PI * 2);
        ctx.strokeStyle = `rgba(0, 255, 255, ${0.3 + glowIntensity * 0.4})`;
        ctx.lineWidth = 1;
        ctx.stroke();

        // Celestial runes on the ring
        ctx.strokeStyle = 'rgba(255, 255, 255, 0.6)';
        ctx.lineWidth = 1.5;
        for (let i = 0; i < 8; i++) {
            ctx.save();
            const angle = (i * Math.PI) / 4;
            const x = Math.cos(angle) * radius;
            const y = Math.sin(angle) * (radius * squish);

            ctx.translate(x, y);
            // Draw a tiny rune (triangle/diamond)
            ctx.beginPath();
            ctx.moveTo(0, -3);
            ctx.lineTo(2, 0);
            ctx.lineTo(0, 3);
            ctx.lineTo(-2, 0);
            ctx.closePath();
            ctx.stroke();

            ctx.restore();
        }

        ctx.restore();
    };

    // --- 2. Multiple Interlocking Armillary Rings ---
    // Outer Meridian Ring (Fixed, Gold)
    drawArmillaryRing(65, 5, 0, 0, rotation * 0.1, 'gold');

    // Equinoctial Ring (Tilted, Bronze)
    drawArmillaryRing(55, 4, Math.PI / 4, Math.PI / 6, -rotation * 0.3, 'bronze');

    // Zodiacal/Ecliptic Ring (Heavily Tilted, Silver, very fast)
    drawArmillaryRing(48, 6, -Math.PI / 3, Math.PI / 3, rotation * 0.6 + time * 0.2, 'silver');

    // Inner Tropic Ring (Slightly tilted, Gold)
    drawArmillaryRing(35, 3, Math.PI / 2, Math.PI / 8, -rotation * 0.8, 'gold');


    // --- 3. Magical Framing / Energy Arcs spanning the sphere ---
    ctx.save();
    ctx.rotate(rotation);
    for (let i = 0; i < 4; i++) {
        ctx.save();
        ctx.rotate((i * Math.PI) / 2 + time);
        ctx.beginPath();
        ctx.arc(0, 0, 75, -Math.PI / 8, Math.PI / 8);
        ctx.strokeStyle = `rgba(0, 255, 255, ${0.5 + glowIntensity * 0.5})`;
        ctx.lineWidth = 2;
        ctx.shadowColor = '#00FFFF';
        ctx.shadowBlur = 10;
        ctx.stroke();

        // Floating point gem
        ctx.beginPath();
        ctx.arc(75, 0, 3, 0, Math.PI * 2);
        ctx.fillStyle = '#FFFFFF';
        ctx.fill();
        ctx.restore();
    }
    ctx.restore();

    ctx.restore();
};
